var React = require('react');

function IconTippyX (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.4372 4C7.4372 4 3.90535 0.00152475 0.598096 0.000371505C-0.963437 -0.000173007 16.6695 -7.20998e-05 14.2763 0.000371505C10.7587 0.00102354 7.4372 4 7.4372 4Z","fill":"currentColor"}));
}

IconTippyX.defaultProps = {"width":"15","height":"4","viewBox":"0 0 15 4","fill":"none"};

module.exports = IconTippyX;

IconTippyX.default = IconTippyX;
